import React from 'react';

import { BodyText, Link } from '@block-explorer/ui';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledWrapper = styled.div(() => ({
  marginTop: '52px',
}));

export function ContractExecutionTosWarning() {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <BodyText size={3} variation="black">
        <Trans t={t}>
          By submitting this form, you agree to our{' '}
          <Link
            color="primaryBlue"
            href={'/tos'}
            target="_blank"
            lineHeight={'xs'}
          >
            Terms of Service.
          </Link>
        </Trans>
      </BodyText>
    </StyledWrapper>
  );
}
export default ContractExecutionTosWarning;
